import { Spinner } from "@goodfill/ui-components";
import { API } from "aws-amplify";
import { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { OrderFormState } from "../state/OrderFormState";
import { OrderReceipt } from "./OrderReceipt";
import { OrderFormLayout } from "../OrderFormLayout";
import { UserAuthDataBalanceAccount } from "../../../backendApi/amplifyGraphQl/CustomGetUserData/UserData";
import { PricedBond } from "../../../bonds/PricedBond";
import { OrderTicketDetailEntity } from "@goodfill/domain-entities";
import { OrderTicketId } from "@goodfill/domain-properties";
import { doGetOrderTicket } from "@goodfill/models-typescript";

export const OrderReceiptContainer = (props: {
  moneyBalanceAccount: UserAuthDataBalanceAccount;
  orderTicketId: OrderTicketId;
  pricedBond: PricedBond;
}) => {
  const { orderTicketId, moneyBalanceAccount, pricedBond } = props;

  const [orderTicket, setOrderTicket] = useState<OrderTicketDetailEntity | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    const init = async () => {
      if (ignore) {
        return;
      }
      setIsLoading(true);
      try {
        const result = await doGetOrderTicket(API, orderTicketId);
        if (ignore) {
          return;
        }
        setOrderTicket(result);
      } catch (e) {
        console.error(e);
        toast.error(`Error: ${e}`);
      } finally {
        if (!ignore) {
          setIsLoading(false);
        }
      }
    };

    init();

    return () => {
      ignore = true;
    };
  }, [orderTicketId]);

  if (isLoading) {
    return <Spinner />;
  }

  if (orderTicket === null) {
    return <>ERROR: OrderTicket to modify not loaded</>;
  }

  const tradeDate = orderTicket.createdAt;

  const orderState = OrderFormState.createFromOrder(orderTicket, pricedBond, tradeDate);

  return (
    <OrderFormLayout pricedBond={props.pricedBond}>
      <OrderReceipt
        result={{
          orderTicket,
          state: orderState,
        }}
        moneyBalanceAccount={moneyBalanceAccount}
        showCalculatedInfo={false}
      />
    </OrderFormLayout>
  );
};
